import { NgModule } from "@angular/core";
import { FooterComponent } from "./components/footer.component";
import { IdleComponent } from "./components/idle-timeout.component";
import { PaginationComponent } from "./components/pagination.component";
import { ProgressBarComponent } from "./components/progress-bar.component";
import { ProgressBarModalComponent } from "./components/progressbar-modal.component";
import { SessionTimeoutComponent } from "./components/session-timeout.component";
import { DataLoaderComponent } from "./components/data-loader.component";
import { AlphaNumericOnlyDirective } from "./directives/alpha-numeric-only.directive";
import { AutofocusDirective } from "./directives/autofocus.directive";
import { BlockCopyPasteDirective } from "./directives/block.directive";
import { DecimalsOnlyDirective } from "./directives/decimals-only.directive";
import { DragAndDropDirective } from "./directives/drag-n-drop.directive";
import { NumbersOnlyDirective } from "./directives/numbers-only.directive";
import { TextOnlyDirective } from "./directives/text-only.directive";
import { TitleOnlyDirective } from "./directives/title-only.directive";
import { UpperCaseDirective } from "./directives/upper-case.directive";
import { TrimValueDirective } from "./directives/trim-value.directive";
import { ThresholdValidatorDirective } from "./directives/threshold.directive";
import { FeatherIconsPipe } from "./pipes/feather.pipe";
import { SortByPipe } from "./pipes/sort.pipe";
import { DatePipe } from "./pipes/date.pipe";
import { PhonePipe } from "./pipes/phone.pipe";
import { SearchFilterPipe } from "./pipes/search-filter.pipe";

@NgModule({
    declarations: [
        FooterComponent,
        ProgressBarModalComponent,
        ProgressBarComponent,
        SessionTimeoutComponent,
        IdleComponent,
        PaginationComponent,
        DataLoaderComponent,
        AutofocusDirective,
        BlockCopyPasteDirective,
        DecimalsOnlyDirective,
        TitleOnlyDirective,
        AlphaNumericOnlyDirective,
        TextOnlyDirective,
        NumbersOnlyDirective,
        UpperCaseDirective,
        TrimValueDirective,
        DragAndDropDirective,
        ThresholdValidatorDirective,
        FeatherIconsPipe,
        SortByPipe,
        PhonePipe,
        DatePipe,
        SearchFilterPipe
    ],
    entryComponents: [ProgressBarModalComponent],
    exports: [
        FooterComponent,
        ProgressBarModalComponent,
        ProgressBarComponent,
        PaginationComponent,
        SessionTimeoutComponent,
        DataLoaderComponent,
        IdleComponent,
        AutofocusDirective,
        BlockCopyPasteDirective,
        DecimalsOnlyDirective,
        AlphaNumericOnlyDirective,
        TitleOnlyDirective,
        TextOnlyDirective,
        NumbersOnlyDirective,
        UpperCaseDirective,
        TrimValueDirective,
        DragAndDropDirective,
        ThresholdValidatorDirective,
        FeatherIconsPipe,
        SortByPipe,
        PhonePipe,
      DatePipe,
      SearchFilterPipe
    ]
})
export class SharedLibsModule {
}
